import React, { useEffect, useState } from "react";
import { readToken } from "utils/session";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { MdBatteryChargingFull, MdFlag, MdNextPlan } from "react-icons/md";
import { FaRoute } from "react-icons/fa";
import { LuCircleParking } from "react-icons/lu";
import { GiUnplugged } from "react-icons/gi";
import { BsDatabaseFillX, BsCashCoin, BsDeviceHdd   } from "react-icons/bs";
import { SlSizeActual } from "react-icons/sl";
import axios from "axios";
import { fetchFleetRows } from "utils/fleetRoster";

function chargingCount(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  if (!("batterychargcurrent" in rows[0]) && !("event" in rows[0])) return null;
  return rows.filter((row) => {
    const current = Number(row.batterychargcurrent);
    const event = Number(row.event);
    return row.batterychargcurrent != null && row.batterychargcurrent !== "" && current !== 0 && event === 0;
  }).length;
}

const SliderTiles = () => {
  // Removed PageRender state as it was unnecessary
  const [card, SetCard] = useState([]);
  
  const icons = [
    { icon: <BsDeviceHdd  className="h-7 w-7 text-blue-1000" /> },
    { icon: <BsCashCoin  className="h-7 w-7 text-blue-1000" /> },
    { icon: <LuCircleParking className="h-7 w-7 text-blue-1000" /> },
    { icon: <GiUnplugged className="h-7 w-7 text-blue-1000" /> },
    { icon: <BsDatabaseFillX className="h-7 w-7 text-blue-1000" /> },
    { icon: <FaRoute className="h-7 w-7 text-blue-1000" /> },
    { icon: <MdFlag className="h-7 w-7 text-blue-1000" /> },
    { icon: <MdNextPlan className="h-7 w-7 text-blue-1000" /> },
    { icon: <SlSizeActual className="h-7 w-7 text-blue-1000" /> },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    slidesPerRow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const USERKEY = readToken();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const getCardSlider = () => {
      if (!USERKEY) return; // Prevent API call if there is no token

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${apiBaseUrl}/api/cardslider`,
        headers: {
          Authorization: `Bearer ${USERKEY}`,
        },
      };
  
      axios
        .request(config)
        .then(async (response) => {
          const cards = response.data?.cardSliderInfo?.cardSliderData || [];
          if (cards.some((item) => item.cardName === "Charging")) {
            SetCard(cards);
            return;
          }
          let value = "—";
          try {
            const rows = await fetchFleetRows({ apiBaseUrl, userKey: USERKEY });
            const counted = chargingCount(rows);
            if (counted != null) value = String(counted);
          } catch (error) {
            console.log(error);
          }
          SetCard([...cards, { cardName: "Charging", cardType: "Normal", value }]);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getCardSlider();
    
    // Dependencies are now strictly limited to variables that won't change 
    // and trigger infinite loops during normal component interaction.
  }, [USERKEY, apiBaseUrl]);

  return (
    <Slider {...settings}>
      {card.map((cardItem, index) => ( // Renamed map variable to cardItem to avoid shadowing the state
        <div
          key={cardItem.cardName || index}
          className="relative h-44 rounded-[6px] bg-white bg-clip-border dark:!bg-navy-800 dark:text-white dark:shadow-none"
        >
          <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
            <div className="rounded-full bg-white p-3 dark:bg-navy-700 shadow-3xl">
              <span className="flex items-center text-brand-500 dark:text-white">
              {cardItem.cardName === "Charging" ? (
                <MdBatteryChargingFull className="h-7 w-7 text-blue-1000" />
              ) : (
                icons[index % icons.length].icon
              )}
              </span>
            </div>
          </div>

          <div className="h-50 ml-4 flex w-auto flex-col justify-center">
          <h4 className="text-l font-bold text-navy-700 dark:text-white">
              {cardItem.cardName}
              
            </h4>
            <p className="font-dm text-l font-medium text-gray-600">
            {cardItem.value} 
            </p>
           
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default SliderTiles;